// 常量定义

// API 基础地址配置（同域部署使用相对路径）
export const API_BASE_URL = '/api/';

// 存储键名
export const STORAGE_KEYS = {
  TOKEN: 'usertoken',
  LOTTERY_TYPE: 'lotteryType',
};

// 彩票类型
export const LOTTERY_TYPES = {
  GANG_CAI: 1, // 港彩
  XIN_AO_CAI: 2, // 新澳彩
  TAI_CAI: 3, // 台彩
  XIN_CAI: 4, // 新彩
  AO_CAI: 5, // 澳彩
  THREE_D: 10, // 3D
};

// 彩票类型名称映射
export const LOTTERY_NAMES: Record<number, string> = {
  1: '港彩',
  2: '新澳彩',
  3: '台彩',
  4: '新彩',
  5: '澳彩',
  10: '3D',
};

// 主题色
export const COLORS = {
  PRIMARY: '#3e73fe',
  SECONDARY: '#ef4343',
  SUCCESS: '#07c160',
  WARNING: '#ff976a',
  ERROR: '#ee0a24',
  WHITE: '#ffffff',
  BLACK: '#000000',
  GRAY: '#646566',
  LIGHT_GRAY: '#f5f5f5',
  BORDER: '#ebedf0',
};

// 屏幕最大宽度
export const MAX_CONTENT_WIDTH = 720;
